import { Search, Menu, TriangleAlert, X, Dot } from 'lucide-react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
export default function Nav() {
    const [displaySearch, setDisplaySearch] = useState(false);
    const [film, setFilm] = useState('');

    const [multiple, setMutliple] = useState([])
    const [displayNav, setDisplayNav] = useState(false)
    const location = useLocation();

    function handleInputChange(e) {
        const value = e.target.value;
        setFilm(value);
        setDisplaySearch(value === '' ? false : true);
    }



    const options = {
        method: 'GET',
        headers: {
            accept: 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwOTFkNDgxN2Y5MDQ1NjIyMTQyZmZkNjdhMDhiMmQxNSIsIm5iZiI6MTcyNzk1NDEyNi4xNDAyMDIsInN1YiI6IjY2ZjdkZDc5MmM0YmRjOWRiMDVmMjUwMSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.I4uN8-MLcRsvD1cf1yZXXaMcTW4_xRqa7z1Jqbrw9gE'
        }
    };
    useEffect(() => {
        fetch(`https://api.themoviedb.org/3/search/multi?query=${film}&include_adult=false&language=en-US&page=1`, options)
            .then(response => response.json())
            .then(response => setMutliple(response.results))
            .catch(err => console.error(err));
    }, [film])

    const navigate = useNavigate()
    const handleNavDisplay = () => {
        setDisplayNav(!displayNav)
        setDisplaySearch(false)
    }

    // console.log(multiple)
    return (
        <>
            <div className=' relative z-[1000] '>
                <header className="lg:absolute z-50 flex flex-wrap lg:justify-start lg:flex-nowrap w-full text-sm py-2 px-1  ">
                    <nav className={ `  w-full mx-auto px-4 lg:flex md:items-center md:justify-between bg-[#7300FF60] rounded-2xl backdrop-blur-lg overflow-hidden transition-all duration-700 ease-in-out h-16  ${displayNav ? 'h-[170px] lg:h-16' : ''}`}>
                        <div className={`flex items-center justify-between duration-500`}>
                            <NavLink onClick={() => setDisplayNav(false)} to={'/'}>
                                <h1 className='text-xl md:text-4xl  text-white text-nowrap flex items-center chokokutai-regular pt-3 md:pt-0'>
                                    <span className='text-[#7300FF] text-3xl md:text-6xl'>HF</span><span> Universe</span>
                                </h1>
                            </NavLink>
                            <button className='lg:hidden border-[1px] border-[#7300FF] rounded-lg p-1 relative top-2 hover:bg-[#7300FF40] duration-200' onClick={handleNavDisplay}>
                                {displayNav ? < X color='white' className='t9iil' size={20} /> : <Menu color='white' className='t9iil' size={20} />}
                            </button>
                        </div>
                        <div className="text-white  flex flex-col gap-5 pb-2 mt-5 lg:flex-row lg:items-center lg:justify-end lg:mt-0 md:ps-5 ">
                            <div className='flex gap-6 md:gap-3 text-lg md:text-sm justify-center'>
                                <NavLink onClick={() => setDisplayNav(false)} to={'/Upcoming'} className={`hover:text-[#7300FF] duration-500 ${location.pathname === '/Upcoming' ? 'text-[#7300FF]' : ''}`}>Upcoming</NavLink>
                                <NavLink onClick={() => setDisplayNav(false)} to={'/Movies'} className={`hover:text-[#7300FF] duration-500 ${location.pathname === '/Movies' ? 'text-[#7300FF]' : ''}`}>Movies</NavLink>
                                <NavLink onClick={() => setDisplayNav(false)} to={'/TvShows'} className={`hover:text-[#7300FF] duration-500 ${location.pathname === '/TvShows' ? 'text-[#7300FF]' : ''}`}>TvShows</NavLink>
                                <NavLink onClick={() => setDisplayNav(false)} to={'/Account'} className={`hover:text-[#7300FF] duration-500 ${location.pathname === '/Account' ? 'text-[#7300FF]' : ''}`}>Account</NavLink>
                            </div>
                            <div className='flex flex-row gap-3 items-center justify-between'>
                                <div className={`border bg-[#7300FF10] w-full  border-[#a473ff] rounded-xl flex items-center pr-2`}>
                                    <input
                                        value={film}
                                        className={`bg-transparent outline-none text-white text-sm w-full px-6 py-3 `}
                                        type='search'
                                        placeholder='Search'
                                        onChange={handleInputChange}
                                    />
                                    <Search color='white' size={26} />
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>

                <div className={`lg:absolute backdrop-blur-lg rounded-xl rounded-tl-none bg-[#7300FF60] xl:w-[40%] h-96  lg:right-[0%] py-3  z-50 top-[72px] ${displaySearch ? 'block' : 'hidden'} overflow-auto 
                    [&::-webkit-scrollbar]:w-1
                    [&::-webkit-scrollbar-track]:rounded-full
                    [&::-webkit-scrollbar-track]:bg-gray-100
                    [&::-webkit-scrollbar-thumb]:rounded-full 
                    [&::-webkit-scrollbar-thumb]:bg-gray-300
                    dark:[&::-webkit-scrollbar-track]:bg-[#7300FF10]
                    dark:[&::-webkit-scrollbar-thumb]:bg-[#7300FF]`}>

                    {/* Search results will be displayed here */}

                    {
                        multiple && multiple.length > 0 ?
                            multiple.map((movie, i, arr) =>
                                movie?.media_type !== 'person' ?
                                    <a href='' className='text-white cursor-pointer' onClick={() => navigate(`/${movie?.id}?type=${movie?.media_type}`)}>
                                        <div className='flex justify-start items-center gap-3 m-2'>
                                            <img src={movie.poster_path ? `https://image.tmdb.org/t/p/w200/${movie?.poster_path}` : "/posterNotFound.jpg"} alt="" className="w-24 rounded-tr-3xl rounded-bl-3xl border-2 border-violet-500 bg-white" />
                                            <div className='flex flex-col justify-center items-start gap-2'>
                                                <h1 className="md:text-2xl text-lg font-bold">{movie?.title} {movie.name}</h1>
                                                <p className='text-sm text-gray-200 font-semibold'>{String(movie?.overview).split(' ').slice(0, 20).join(' ')} {String(movie?.overview).split(' ').length < 30 ? '' : <span className='text-[#a473ff]'>see more</span>}</p>
                                                <div className='flex items-center'>
                                                    <p className='bg-indigo-500 text-white py-1 px-2 rounded-md capitalize'>{movie?.media_type}</p>
                                                    {movie?.release_date ?
                                                        <>
                                                            <Dot />
                                                            <p>{String(movie?.release_date)?.split('-')[0]}</p>
                                                        </> : ''
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </a> : ''

                            )
                            : <div className='text-white text-2xl flex flex-col items-center gap-3 m-4'>
                                <TriangleAlert size={40} />
                                <span>No Movie or Tv show found</span>

                            </div>
                    }
                </div>
            </div>
            <div className={` w-lvw h-lvh z-[999] fixed   top-0 left-0 ${displaySearch ? 'block' : 'hidden'} `} onClick={() => { setDisplaySearch(false) }}></div>
        </>
    );
}
